window.lang2 =
{
  "general": {
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 Page Not Found",
      "subtext_html": "The page you requested does not exist. Click <a href=\"\/collections\/all\">here<\/a> to continue shopping."
    },
    "breadcrumbs": {
      "home": "Home",
      "home_link_title": "Back to the frontpage"
    },
    "newsletter_form": {
      "title": "Newsletter",
      "newsletter_email": "Email Address",
      "submit": "Submit",
      "text": "Enter your e-mail Address",
      "noitice": "Don’t show this popup again",
      "go": "Go!",
      "ok": "ok",
      "subscribe": "subscribe"
    },
    "search": {
      "no_results_html": "Search results for \"{{ terms }}\"",
      "results_for_html": "Search results for \"{{ terms }}\"",
      "title": "Search for products on our site",
      "placeholder": "Search...",
      "submit": "Search",
      "category": "Select category",
      "info_search": "Start typing to see products you are looking for.",
      "not_found": "No products found",
      "view_results": "View all results"
    },
    "date": {
      "year_text": "years",
      "month_text": "months",
      "week_text": "weeks",
      "day_text": "days",
      "year_singular_text": "year",
      "month_singular_text": "month",
      "week_singular_text": "week",
      "day_singular_text": "day",
      "hour_text": "Hours",
      "min_text": "Mins",
      "sec_text": "Secs",
      "hour_singular_text": "Hour",
      "min_singular_text": "Min",
      "sec_singular_text": "Sec"
    },
    "modal": {
      "wishlist_text": "Excl. postage",
      "continue_shopping": "Continue",
      "go_to_wishlist": "My Wishlist",
      "add_to_wishlist_message": "Just added to your wishlist:",
      "cart_text": "Excl. postage",
      "go_to_cart": "Go to cart page",
      "add_to_cart_message": "You've just added this product to the cart:",
      "qty": "Qty:",
      "total": "Total:"
    }
  },
  "header": {
    "settings": {
      "login": "Sign in or Create an Account",
      "register": "Register",
      "logout": "Logout",
      "my_account": "My Account",
      "wishlist": "My Wishlist",
      "compare": "Compare",
      "currency": "Currency",
      "newsletter_signup": "Newsletter Signup",
      "language": "Your Languages",
      "daily_deal": "Daily deal",
      "blog": "Blog",
      "links": "Links",
      "shop": "Shop"
    },
    "topbar": {
      "my_cart": "My cart",
      "search": "Search"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "{{ date }}",
      "by_admin": "By {{ author }}",
      "older_post": "Older Post",
      "newer_post": "Newer Post",
      "tags": "Tags",
      "read_more": "Read more",
      "share_post": "Share: "
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name *",
      "email": "Email *",
      "message": "Message *",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "comments ({{ count }})"
      }
    },
    "sidebar": {
      "recent_articles": "Recent Posts",
      "categories": "Blog Categories",
      "video": "Latest Video",
      "tags": "Tag Cloud",
      "search_placeholder": "Search posts here..."
    },
    "related_posts": "Related Posts"
  },
  "cart": {
    "general": {
      "title": "Shopping Cart",
      "remove": "Remove",
      "edit": "Edit",
      "note": "Special instructions for seller",
      "carttotals": "Cart Totals",
      "subtotal": "Subtotal",
      "grandtotal": "Grand Total",
      "shipping_at_checkout": "Checkout with Multiple Addresses",
      "continue": "Continue Shopping",
      "update": "Update Shopping Cart",
      "checkout": "Proceed to checkout",
      "empty": "Your cart is currently empty.",
      "continue_browsing_html": "Continue browsing <a href=\"\/collections\/all\">here<\/a>.",
      "close_cart": "Close Cart",
      "shipping_calculator_error_message": "Error: Please enter right shipping information",
      "shipping_calculator_success_many_rates": {
        "there_are": "There are",
        "shipping_rates_available_for": "shipping rates available for",
        "starting_at": ", starting at"
      },
      "shipping_calculator_success_one_rate": "There is one shipping rate available for",
      "shipping_calculator_success_no_rate": "There is no shipping rate available for this order and destination.",
      "shipping_calculator_success_at": "at"
    },
    "header": {
      "view_cart": "View cart",
      "checkout": "Checkout",
      "total": "Total:",
      "total_numb": "item(s)",
      "no_item": "You have no items in your shopping cart.",
      "remove_this_item": "Remove item"
    },
    "label": {
      "product": "Product Name",
      "price": "Unit Price",
      "quantity": "Qty",
      "update_cart": "Update Cart",
      "remove": "Remove",
      "total": "Total"
    },
    "shipping": {
      "title": "Estimate Shipping and Tax",
      "title_form": "Enter your destination to get a shipping estimate.",
      "country": "Country",
      "state": "State",
      "zip": "Zip\/Postal Code",
      "submit_button": "Get a Quote",
      "submit_button_when_calculating": "Calculating..."
    }
  },
  "collections": {
    "general": {
      "title": "List Collections",
      "all_of_collection": "All {{ collection }}",
      "no_matches": "Sorry, there are no products in this collection",
      "link_title": "Browse our {{ title }} collection",
      "grid_view": "Grid view",
      "list_view": "List view",
      "view_all": "view all",
      "shop_the_collection": "Shop The Collection",
      "items_with_count": {
        "one": "{{ count }} Products",
        "other": "{{ count }} Products"
      },
      "clear": "Clear",
      "refine_by": "Refine By",
      "clear_all": "Clear all",
      "filter": "Filter",
      "showing": "Showing",
      "of": "of",
      "previous": "Previous",
      "next": "Next",
      "show_more": "Load More",
      "loading": "Loading",
      "no_more_product": "No more product",
      "quickview": "Quick View"
    },
    "sidebar": {
      "categories": "Categories",
      "shopby": "Shop by",
      "tags": "Tag Cloud"
    },
    "sorting": {
      "title": "Sort by",
      "featured": "Featured",
      "best_selling": "Best Selling",
      "az": "Name, A-Z",
      "za": "Name, Z-A",
      "price_ascending": "Price, low to high",
      "price_descending": "Price, high to low",
      "date_descending": "Date, new to old",
      "date_ascending": "Date, old to new",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "All"
    },
    "limiter": {
      "title": "Show",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "All"
    },
    "onboarding": {
      "modal_title": "This page will show all of your store's products",
      "no_products_html": "There are no products yet, but once you begin adding them they will show up here regardless if they are in a collection.",
      "add_product": "Add Product"
    },
    "onepage": {
      "seemore": "See More"
    }
  },
  "contact": {
    "form": {
      "title": "Leave a ",
      "title_after": "Message",
      "name": "Name",
      "email": "Email",
      "phone": "Telephone",
      "comment": "Comment",
      "send": "Send Message",
      "submit": "submit",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible."
    }
  },
  "customer": {
    "account": {
      "title": "My Account",
      "details": "Account Details",
      "view_addresses": "View Addresses",
      "return": "Return to Account Details"
    },
    "activate_account": {
      "title": "Activate Account",
      "subtext": "Create your password to activate your account.",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Activate Account",
      "cancel": "Decline Invitation"
    },
    "addresses": {
      "title": "Your Addresses",
      "default": "Default",
      "add_new": "Add a New Address",
      "edit_address": "Edit address",
      "first_name": "First Name",
      "last_name": "Last Name",
      "company": "Company",
      "address1": "Address1",
      "address2": "Address2",
      "city": "City",
      "country": "Country",
      "province": "Province",
      "zip": "Postal\/Zip Code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add Address",
      "update": "Update Address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "delete_message": "Are you sure you wish to delete this address?"
    },
    "login": {
      "heading": "Login or Create an Account",
      "page_title": "Login",
      "title": "Registered Customers",
      "content": "If you have an account with us, please log in.",
      "email": "Email Address",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "log_in": "Log in",
      "cancel": "Return to Store",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue",
      "register": "New Customers",
      "register_content": "By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.",
      "register_button": "Create an Account"
    },
    "logout": {
      "title": "Logout"
    },
    "orders": {
      "title": "Order History",
      "order_number": "Order",
      "date": "Date",
      "payment_status": "Payment",
      "fulfillment_status": "Fulfillment",
      "total": "Total",
      "none": "You haven't placed any orders yet."
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Placed on {{ date }}",
      "cancelled": "Order Cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing Address",
      "payment_status": "Payment Status",
      "shipping_address": "Shipping Address",
      "fulfillment_status": "Fulfillment Status",
      "discount": "Discount",
      "shipping": "Shipping",
      "tax": "Tax",
      "product": "Product",
      "sku": "SKU",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "fulfilled_at": "Fulfilled {{ date }}",
      "subtotal": "Subtotal"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Back to Login",
      "subtext": "We will send you an email to reset your password.",
      "success": "We've sent you an email with a link to update your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for {{ email }}",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Reset Password"
    },
    "register": {
      "page_title": "Register",
      "title": "Create Account",
      "title_form": "Personal Information",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "password": "Password",
      "submit": "Submit",
      "required": "* Required Fields",
      "cancel": "Return to Store",
      "message": "Please enter the following information to create your account."
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Frontpage Collection",
      "featured_title": "Featured Collections",
      "news_title": "Latest News"
    },
    "onboarding": {
      "modal_title": "Almost there...",
      "no_products_html": "You have no products in your Frontpage collection. This placeholder will appear until you <a href=\"\/admin\/collections?tutorial=Frontpage\">add a product to this collection<\/a>.",
      "add_product": "Add a Product",
      "product_title": "Example Product Title",
      "no_collections_html": "You don't have any collections to show here. <a href=\"\/admin\/custom_collections\">Add some collections<\/a> to go along with the default Frontpage.",
      "add_collection": "Add a Collection",
      "collection_title": "Example Collection Title"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menu"
    },
    "drawers": {
      "browse": "Browse",
      "close_menu": "Close menu"
    },
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Logged in as {{ first_name }}",
      "log_out": "Log out",
      "log_in": "Log in",
      "create_account": "Create account"
    },
    "footer": {
      "social_title": "Get Connected",
      "newsletter_title": "Newsletter",
      "accepted_payments": "Accepted Payments"
    }
  },
  "wish_list": {
    "general": {
      "wishlist": "Wishlist",
      "add_to_wishlist": "Add to wishlist",
      "browse_wishlist": "Browse wishlist",
      "product": "Product",
      "price": "Price",
      "remove": "has removed from wishlist",
      "quantity": "Quantity",
      "options": "Options",
      "no_item": "There is no items in wishlist box",
      "item_exist": "is exist in wishlist",
      "item_added": "has added to wishlist successful"
    }
  },
  "compare_list": {
    "general": {
      "compare": "Comparing box",
      "add_to_compare": "Add to compare",
      "price": "Price",
      "product": "Product",
      "remove": "has removed from comparing box",
      "quantity": "Quantity",
      "options": "Options",
      "no_item": "There is no items in comparing box",
      "item_exist": "is exist in compare",
      "item_added": "has added to comparing box successful",
      "features": "Features",
      "actions": "Actions"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Previous Product",
      "next_product_html": "Next Product &rarr;",
      "from_text_html": "From {{ price }}",
      "sale_price": "Sale price",
      "regular_price": "Regular price",
      "related_products": "Also Purchased",
      "sale": "Sale",
      "show_all": "Show all",
      "show_more": "Load more",
      "no_more_product": "No more products",
      "view_all": "View All Products"
    },
    "product": {
      "quickview": "quick view",
      "sold_out": "Sold Out",
      "on_sale": "On Sale",
      "on_sale_from_html": "{{ price }}",
      "unavailable": "Unavailable",
      "compare_at": "Compare at",
      "quantity": "Qty",
      "add_to_cart": "Add to Cart",
      "select_options": "Select Options",
      "tab_title_description": "More Information",
      "tab_title_review": "Reviews",
      "share": "Share:",
      "availability": "Availability:",
      "sku": "Sku:",
      "in_stock": "In Stock",
      "out_of_stock": "Out Of Stock",
      "many_in_stock": "Many In Stock",
      "product_type": "Product Type:",
      "product_vendor": "Vendor:",
      "count_down": "Limited-Time Offers, End in:"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Here's your {{ value }} gift card for {{ shop }}!",
      "subtext": "Here's your gift card!",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem": "Use this code at checkout to redeem your gift card",
      "shop_link": "Start shopping",
      "print": "Print"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  }
}